import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ESRI, GIS, GOOGLE } from '@rsos/constants/reverseGeocodeServices';
import { useBooleanFlagValue } from '@rsos/feature-flags';
import { selectGeocodeService } from '@rsos/reduxDataStore/src/features/gisServices/gisServicesSlice';
import checkGISServicesAccess from '@rsos/utils/checkGISServicesAccess';
import usePortalType from '@rsos/utils/usePortalType';

/**
 * Determines which reverse geocode service to use based on capabilities and permissions.
 * Possible values: gis, esri, or google.
 *
 * Priority (flag off): local GIS > Esri > Google
 * Priority (use_default_google_geocoder): local GIS > Google > Esri
 */
const useWhichReverseGeocodeService = () => {
  const [service, setService] = useState('');

  const { isPremiumUser } = usePortalType();
  const useDefaultGoogleGeocoder = useBooleanFlagValue(
    'use_default_google_geocoder',
    false,
  );

  const hasGISServicesAccess = useSelector(state =>
    checkGISServicesAccess({
      psaps: state.psaps,
      sinatra: state.sinatra,
    }),
  );

  const hasGISGeocodeService = useSelector(
    state => !!selectGeocodeService(state),
  );

  useEffect(() => {
    if (hasGISServicesAccess && hasGISGeocodeService) {
      setService(GIS);
    } else if (useDefaultGoogleGeocoder) {
      setService(GOOGLE);
    } else if (isPremiumUser) {
      setService(ESRI);
    } else {
      setService(GOOGLE);
    }
  }, [
    hasGISGeocodeService,
    hasGISServicesAccess,
    isPremiumUser,
    useDefaultGoogleGeocoder,
  ]);

  return service;
};

export default useWhichReverseGeocodeService;
